import { render, staticRenderFns } from "./AboutTetra.vue?vue&type=template&id=7461d02e&scoped=true"
import script from "./AboutTetra.vue?vue&type=script&lang=js"
export * from "./AboutTetra.vue?vue&type=script&lang=js"
import style0 from "./AboutTetra.vue?vue&type=style&index=0&id=7461d02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7461d02e",
  null
  
)

export default component.exports